<kendo-dialog [title]="selectedImport?.title" *ngIf="opened" (close)="close()" [minWidth]="250" [width]="450">
  <div>
    <mdb-card cascade="true" narrower="true">
        <small ><i class="m-3 k-icon k-i-information"></i> You can drag and drop your file here.</small>
      <kendo-upload
        [saveUrl]="uploadSaveUrl"
        (upload)="uploadEventHandler($event)"
        [withCredentials]="false"
        (success)="successEventHandler($event)"
        (error)="errorEventHandler($event)"
        [restrictions]="fileRestrictions"
        [multiple]="false"
      >
      </kendo-upload>
      <div class="ml-3">
        {{ UploadType }}
      </div>
      <kendo-radialgauge #radial [pointer]="{ value: UploadValue }" *ngIf="UploadValue > 0.1"> </kendo-radialgauge>
      <div class="alert alert-danger m-1 import2-errors" role="alert" *ngIf="IsError">
        <div *ngFor="let item of errorList">
          {{ item }}
        </div>
      </div>
    </mdb-card>
  </div>
</kendo-dialog>
